import React, { useContext, useEffect, useState } from 'react'
import { MovementContext } from '../../context/movementContext/MovementContext';
import FormInput from '../../components/formInput/FormInput';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import { useNavigate } from 'react-router-dom';
import ImageLoader from '../../components/imageLoader/ImageLoader';
import { submitDechargeRetourAutre } from '../../context/movementContext/apiCalls';

export default function DechargeRetourAutre() {
    const { dispatch, message, isFetchingRetourAutreSubmit, errorRetourAutreSubmit } = useContext(MovementContext);
    const [errorBox, setErrorBox] = useState("");

    const [montant, setMontant] = useState("");
    const [motif, setMotif] = useState("");
    const [file, setFile] = useState(null);

    const navigate = useNavigate()

    useEffect(() => {
        if (errorRetourAutreSubmit !== "") {
            setErrorBox(errorRetourAutreSubmit)
        }
    }, [errorRetourAutreSubmit])

    useEffect(() => {
        if (message !== "") {
            dispatch({ type: "CLEAR_MOVEMENT" });
            navigate('/movements');
        }
    }, [message])

    const handleMovementDecharge = () => {
        if (montant.trim() == "") {
            setErrorBox(`Vous devez compléter le Montant`);
            return;
        }
        if (isNaN(montant)) {
            setErrorBox(`Montant doit etre un nombre`);
            return;
        }
        if (motif.trim() == "") {
            setErrorBox(`Vous devez compléter le Motif`);
            return;
        }
        if(!file) {
            setErrorBox(`Vous devez attacher une image`);
            return;
        }

        setErrorBox("")
        submitDechargeRetourAutre(dispatch, montant, motif, file);
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="movement" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Créer un Déchargement :</span>
                </div>

                {errorBox && <ErrorComponent error={errorBox} />}

                <div className="content invoice" style={{ marginTop: '20px' }}>
                    <div className="box" style={{ width: '600px' }}>
                        <div className="box-content">
                            <FormInput label='Montant' itemInput={montant} setItemInput={setMontant} auth istype='number' />
                            <FormInput label='Motif' itemInput={motif} setItemInput={setMotif} auth />
                            <ImageLoader imageLabel={"Attacher Image"} fileDecharge={file} setFileDecharge={setFile} />
                            <div className='button' onClick={handleMovementDecharge} style={isFetchingRetourAutreSubmit ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                <span>
                                    {isFetchingRetourAutreSubmit ? "Décharger ..." : "Décharger"}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
